import React, { useContext, useState } from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  makeStyles,
  Link,
  Button,
} from "@material-ui/core";
import RobotCard from "src/component/RobotCard";
import MintButton from "src/component/MintButton";
import { UserContext } from "src/context/User";
import { useWeb3React } from "@web3-react/core";
import { ACTIVE_NETWORK, GenerativeNFTContract } from "src/constants";
import { getContract, swichNetworkHandler } from "src/utils";
import GenerativeNFTABI from "src/ABI/GenerativeNFTABI.json";
import { toast } from "react-toastify";
import ButtonCircularProgress from "src/component/ButtonCircularProgress";

const TeamMap = [
  {
    img: "images/robotcard.png",
    text1: "75%",
    text2: "Common",
    text3: "250",
    color: "#E6FFBC",
  },
  {
    img: "images/epic.png",
    text1: "25%",
    text2: "Epic",
    text3: "250",
    color: "#FFC79D",
  },
  {
    img: "images/legendry.png",
    text1: "5%",
    text2: "Rarity",
    text3: "250",
    color: "#CEE3F0",
  },
];

const useStyles = makeStyles((theme) => ({
  MintSection: {
    position: "relative",
    width: "100%",
  },
  mainbox: {
    width: "100%",
    padding: "80px 0 80px",
    "& h2": {
      fontSize: "50px",
      fontWeight: "400",
      color: "#fff",
      marginTop: "30px",
      "@media(max-width:768px)": {
        fontSize: "30px",
      },
    },
    "& p": {
      fontSize: "15px",
      fontWeight: "400",
      color: "#ffffff",

      "@media(max-width:375px)": {
        fontSize: "14px",
      },
    },
  },
  topleft: {
    position: "absolute",
    top: "-36px",
    left: "0px",
    zIndex: "1",
    width: "100%",
    maxWidth: "600px",
    [theme.breakpoints.down("md")]: {
      top: "-17px",
      width: "25%",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  topright: {
    position: "absolute",
    top: "-36px",
    right: "0px",
    zIndex: "1",
    width: "100%",
    maxWidth: "600px",
    [theme.breakpoints.down("md")]: {
      top: "-17px",
      width: "25%",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  botomleft: {
    position: "absolute",
    bottom: "-36px",
    left: "0px",
    zIndex: "9",
    width: "100%",
    maxWidth: "600px",
    [theme.breakpoints.down("md")]: {
      bottom: "-17px",
      width: "25%",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  botomright: {
    position: "absolute",
    bottom: "-36px",
    right: "0px",
    zIndex: "9",
    width: "100%",
    maxWidth: "600px",
    [theme.breakpoints.down("md")]: {
      bottom: "-17px",
      width: "25%",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

function MintSection() {
  const classes = useStyles();
  const user = useContext(UserContext);
  const { account, library, chainId } = useWeb3React();
  const [isLoading, setIsLoading] = useState();

  const mintCommonHandler = async () => {
    if (chainId == ACTIVE_NETWORK) {
      try {
        setIsLoading("common");
        const contractObj = getContract(
          GenerativeNFTContract,
          GenerativeNFTABI,
          library,
          account
        );
        const NFTMinted = await contractObj.commonNFTMinted();
        const TotalNFT = await contractObj.commonTotalNFT();
        const nftPrice = await contractObj.NFT_PRICE_COMMON();
        if (Number(NFTMinted.toString()) + 1 <= Number(TotalNFT.toString())) {
          const res = await contractObj.mintCommon("1", {
            value: nftPrice,
          });
          await res.wait();
          console.log("contractObj", contractObj);
          toast.success("Success");
          user.getCurrentMintingDetails();
        } else {
          toast.warn("Exceeds MAX_NFT_SUPPLY");
        }
        setIsLoading();
      } catch (error) {
        setIsLoading();

        if (error?.data?.message) {
          toast.error(error?.data?.message);
        } else {
          toast.error(error.message);
        }
        console.log("ERROR", error);
      }
    } else {
      swichNetworkHandler(ACTIVE_NETWORK);
    }
  };

  const mintEpicHandler = async () => {
    if (chainId == ACTIVE_NETWORK) {
      try {
        setIsLoading("epic");
        const contractObj = getContract(
          GenerativeNFTContract,
          GenerativeNFTABI,
          library,
          account
        );
        const NFTMinted = await contractObj.epicNFTMinted();
        const TotalNFT = await contractObj.epicTotalNFT();
        const nftPrice = await contractObj.NFT_PRICE_EPIC();
        if (Number(NFTMinted.toString()) + 1 <= Number(TotalNFT.toString())) {
          const res = await contractObj.mintEpic("1", {
            value: nftPrice,
          });
          await res.wait();
          console.log("contractObj", contractObj);
          toast.success("Success");
          user.getCurrentMintingDetails();
        } else {
          toast.warn("Exceeds MAX_NFT_SUPPLY");
        }
        setIsLoading();
      } catch (error) {
        setIsLoading();

        if (error?.data?.message) {
          toast.error(error?.data?.message);
        } else {
          toast.error(error.message);
        }
        console.log("ERROR", error);
      }
    } else {
      swichNetworkHandler(ACTIVE_NETWORK);
    }
  };

  const mintRareHandler = async () => {
    if (chainId == ACTIVE_NETWORK) {
      try {
        setIsLoading("rare");
        const contractObj = getContract(
          GenerativeNFTContract,
          GenerativeNFTABI,
          library,
          account
        );
        const NFTMinted = await contractObj.rareNFTMinted();
        const TotalNFT = await contractObj.rareTotalNFT();
        const nftPrice = await contractObj.NFT_PRICE_RARE();
        if (Number(NFTMinted.toString()) + 1 <= Number(TotalNFT.toString())) {
          const res = await contractObj.mintRare("1", {
            value: nftPrice,
          });
          await res.wait();
          console.log("contractObj", contractObj);
          toast.success("Success");
          user.getCurrentMintingDetails();
        } else {
          toast.warn("Exceeds MAX_NFT_SUPPLY");
        }
        setIsLoading();
      } catch (error) {
        setIsLoading();

        if (error?.data?.message) {
          toast.error(error?.data?.message);
        } else {
          toast.error(error.message);
        }
        console.log("ERROR", error);
      }
    } else {
      swichNetworkHandler(ACTIVE_NETWORK);
    }
  };

  return (
    <>
      <Box className={classes.MintSection}>
        <img
          src='images/topleftarrow.png'
          alt='Top Left Arrow'
          className={classes.topleft}
        />
        <img
          src='images/toprightarrow.png'
          alt='Top Right Arrow'
          className={classes.topright}
        />

        <Container maxWidth='lg'>
          <Box className={classes.mainbox}>
            <Typography variant='h2'>MINT</Typography>
            <Box mt={2}>
              <Typography variant='body2'>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the.Lorem Ipsum is simply dummy
                text of the printing and typesetting industry. Lorem Ipsum has
                been the.Lorem Ipsum is simply dummy text of the printing and
                typesetting industry. Lorem Ipsum has been the.Lorem Ipsum is
                simply dummy text of the printing and typesetting industry.
                Lorem Ipsum has been the.Lorem Ipsum is simply dummy text of the
                printing and typesetting industry. Lorem Ipsum has been
                the.Lorem Ipsum is simply dummy text of the printing and
                typesetting industry. Lorem Ipsum has been the.Lorem Ipsum is
                simply dummy text of the printing and typesetting industry.
                Lorem Ipsum has been the.Lorem Ipsum is simply dummy text of the
                printing and typesetting industry. Lorem Ipsum has been the.
              </Typography>
            </Box>

            <Box mt={8} mb={8}>
              <Grid container spacing={5} textAlign='center'>
                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <RobotCard
                    data={TeamMap[0]}
                    index={0}
                    qty={user?.commonTotalNFT}
                    percentage={
                      (Number(user?.commonTotalNFT) /
                        Number(user?.MAX_NFT_SUPPLY)) *
                      100
                    }
                  />
                  <Box textAlign='center' mt={3}>
                    <MintButton
                      disabled={isLoading}
                      fullWidth
                      onClick={mintCommonHandler}
                    >
                      {isLoading === "common" && <ButtonCircularProgress />}
                    </MintButton>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <RobotCard
                    data={TeamMap[1]}
                    index={1}
                    qty={user?.epicTotalNFT}
                    percentage={
                      (Number(user?.epicTotalNFT) /
                        Number(user?.MAX_NFT_SUPPLY)) *
                      100
                    }
                  />
                  <Box textAlign='center' mt={3}>
                    <MintButton
                      disabled={isLoading}
                      fullWidth
                      onClick={mintEpicHandler}
                    >
                      {isLoading === "epic" && <ButtonCircularProgress />}
                    </MintButton>
                  </Box>
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={4}>
                  <RobotCard
                    data={TeamMap[2]}
                    index={2}
                    qty={user?.rareTotalNFT}
                    percentage={
                      (Number(user?.rareTotalNFT) /
                        Number(user?.MAX_NFT_SUPPLY)) *
                      100
                    }
                  />

                  <Box textAlign='center' mt={3}>
                    <MintButton
                      disabled={isLoading}
                      fullWidth
                      onClick={mintRareHandler}
                    >
                      {isLoading === "rare" && <ButtonCircularProgress />}
                    </MintButton>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Container>

        <img
          src='images/bottomleftarrow.png'
          alt='Bottom Left Arrow'
          className={classes.botomleft}
        />
        <img
          src='images/bottomrightarrow.png'
          alt='Bottom Right Arrow'
          className={classes.botomright}
        />
      </Box>
    </>
  );
}

export default MintSection;
